import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Dropdown,
  FormControl,
  FormGroup,
  MenuItem,
  Row,
} from 'react-bootstrap';
import { upperCase } from 'lodash/fp';
import { FeeCategory } from '@upstart/harmony/lib/constants';

function AddFeeSection(props) {
  const { onFeeAdd } = props;

  const [name, setName] = useState('');
  const [value, setValue] = useState(0);
  const [category, setCategory] = useState(FeeCategory.NON_TAXABLE);

  const feeCategories = Object.entries(FeeCategory).map(([, f]) => f);
  return (
    <Row>
      <FormGroup
        controlId="add-fee-form"
        className="formGroup form-inline form-group"
      >
        <Col md={3}>
          <FormControl
            name="add-fee-name"
            type="string"
            className="wideInput"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <FormControl
            name="add-fee-value"
            type="number"
            value={value}
            onChange={e => setValue(parseFloat(e.target.value, 10))}
          />
        </Col>
        <Col md={3} className="text-right">
          <Dropdown
            className="dropdown dropdown-trigger"
            id="user-dropdown-basic"
          >
            <Dropdown.Toggle
              className="dropdown-label"
              id="user-dropdown-toggle"
            >
              {upperCase(category)}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {feeCategories.map(f => (
                <MenuItem key={f} onSelect={() => setCategory(f)}>
                  {upperCase(f)}
                </MenuItem>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col md={1}>
          <button
            className="btn btn-primary"
            onClick={() => {
              setName('');
              setValue(0);
              setCategory(FeeCategory.NON_TAXABLE);
              onFeeAdd(name, value, category);
            }}
          >
            +
          </button>
        </Col>
      </FormGroup>
    </Row>
  );
}

AddFeeSection.propTypes = {
  onFeeAdd: PropTypes.func,
};

export default AddFeeSection;
